import { gql } from 'apollo-boost';

export const RERUN_ADMIN_VIDEO_FRAME_ANALYSIS_JOBS = gql`
    mutation RerunAdminVideoFrameAnalysisJobs($data: RerunAdminVideoFrameAnalysisJobsInput) {
        rerunAdminVideoFrameAnalysisJobs(data: $data) {
            matchedCount
            modifiedCount
            analysisIds
        }
    }
`;
